import { ReactNode } from 'react'
import * as Styled from './styles'

interface TitleProps {
  children: ReactNode
}

export const SnackTitle = ({ children }: TitleProps) => {
  return <Styled.Container>{children}</Styled.Container>
}
